import { css } from 'styled-components/macro';
import {
  colourGreen07,
  colourGreen10,
  colourNeutral08,
  colourRed07,
  colourRed08,
  colourRed10,
  colourYellow05,
  colourYellow09,
} from '../../../styling/colours';
import { fontFamily, fontSize01, fontSize03 } from '../../../styling/fonts';
import { spacing02, spacing03 } from '../../../styling/spacing';

export const inputSidePadding = spacing03;
export const inputBorderWidth = '1px';
export const inputStyles = ({
  $isValid,
  $isInvalid,
  $hasWarning,
  $isSmall,
}: {
  $isValid?: boolean;
  $isInvalid?: boolean;
  $hasWarning?: boolean;
  $isSmall?: boolean;
}) => css`
  font-family: ${fontFamily};
  font-size: ${$isSmall ? fontSize01 : fontSize03};
  padding: ${spacing02} ${inputSidePadding};
  outline: none;
  border: solid ${inputBorderWidth}
    ${($hasWarning && colourYellow05) ||
      ($isValid && colourGreen07) ||
      ($isInvalid && colourRed07) ||
      'rgba(0, 0, 0, 0.15)'};
  background-color: ${($hasWarning && colourYellow09) ||
    ($isValid && colourGreen10) ||
    ($isInvalid && colourRed10) ||
    'rgba(255, 255, 255, 0.95)'};
  transition: all 0.5s ease;
  width: calc(100% - ${inputSidePadding} - ${inputSidePadding} - ${inputBorderWidth} - ${inputBorderWidth});

  &:focus,
  &:active {
    border-color: ${($isValid && colourGreen07) || ($isInvalid && colourRed08) || colourNeutral08};
    background-color: white;
  }

  &:disabled {
    opacity: 0.9;
    cursor: not-allowed;
  }
`;
